<mat-accordion class="management-accordion">
    <mat-expansion-panel
        [expanded]="!isFormDisplayed()"
        (opened)="hideForm()"
        (closed)="setDisplayMode(DisplayMode.Form)"
        hideToggle
        class="panel-list"
        [ngClass]="{ expanded: isFormDisplayed() }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.viewContext.formVisible, 'events-active': context?.viewContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Vues"
                createIconText="Ajouter une vue"
                importDatasourceName="views"
                (created)="onViewCreated()"
                (exported)="onViewsExported()"
                (imported)="onViewsImported()"
                (helped)="onViewsHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-views-list
            (itemSelected)="onViewSelected($event)"
            (itemDisplayed)="onViewDisplayed($event)"
            (itemEdited)="onViewEdited($event)"
            (itemDeleted)="onViewDeleted($event)"
            (itemDuplicated)="onViewDuplicated($event)"
            (archivingActivated)="onViewArchivingActivated($event)"
            (cloned)="onViewCloned($event)"></app-views-list>
    </mat-expansion-panel>

    @if (isFormDisplayed()) {
        <mat-expansion-panel
            [disabled]="!context?.viewContext.formVisible"
            [expanded]="isFormDisplayed()"
            (opened)="setDisplayMode(DisplayMode.Form)"
            (closed)="hideForm()"
            hideToggle
            class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.viewContext.view.getDisplayName()"
                    [id]="context?.viewContext.view.id"
                    (displayed)="onViewDisplayed(context?.viewContext.view)"
                    (edited)="onViewEdited(context?.viewContext.view)"
                    (helped)="onViewsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-view-detail
                [context]="context"
                (viewUpdated)="onViewUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-view-detail>
        </mat-expansion-panel>
    }
</mat-accordion>

<app-server-progress-bar-spinner></app-server-progress-bar-spinner>
